firebird.filter('nameStartsWith', function () {
    return function (name, filter) {
        if (typeof name !== 'string' || typeof filter !== 'string') {
            return false;
        }

        var lowerCaseName = name.toLowerCase();
        var lowerCaseFilter = filter.toLowerCase();

        return lowerCaseName.indexOf(lowerCaseFilter) === 0;
    };
});
